import { MatSnackBarConfig } from "@angular/material/snack-bar";

export const snackPrimary: MatSnackBarConfig = {
    panelClass: 'snackbar-primary',
};

export const snackSuccess: MatSnackBarConfig = {
    panelClass: 'snackbar-success',
};

export const snackWarning: MatSnackBarConfig = {
    panelClass: 'snackbar-warning',
};

export const snackInfo: MatSnackBarConfig = {
    panelClass: 'snackbar-info',
};

export const snackError: MatSnackBarConfig = {
    panelClass: 'snackbar-error',
};
